import React from "react"
export function WalletCash(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M11.745 2.098l.056.048 4.513 4.51a.5.5 0 01.048.65l-.03.035h-1.411l.332-.332-3.806-3.803-.374.372-.003-.002L9.656 4.99l.002.003-2.35 2.349H5.896l3.32-3.317-.832-.822-4.188 4.139H2.961a.498.498 0 01.099-.274l.05-.057 4.922-4.866a.5.5 0 01.647-.047l.056.047 1.187 1.173 1.172-1.17a.5.5 0 01.651-.049zm1.552 5.161l-.049.056-.026.026h-1.423l.386-.381-.278-.276h1.406a.5.5 0 01-.016.575zm3.37-.584c.703 0 1.278.544 1.33 1.233l.003.1v8.66c0 .702-.544 1.277-1.234 1.328l-.1.004H3.334a1.333 1.333 0 01-1.33-1.233l-.003-.1v-8.66c0-.702.544-1.277 1.234-1.328l.1-.004h13.333zm0 1H3.333l-.06.005a.334.334 0 00-.268.268L3 8.008v8.66l.005.06a.334.334 0 00.268.267l.06.006h13.334l.06-.006a.334.334 0 00.268-.267l.005-.06v-8.66l-.005-.06a.334.334 0 00-.268-.268l-.06-.006zM14 10.504a1.833 1.833 0 11.001 3.666A1.833 1.833 0 0114 10.506zm0 1a.833.833 0 100 1.666.833.833 0 000-1.666z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__cash"
        />
      </g>
    </svg>
  )
}
